import { useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { SEARCH_PARAMS } from "@/lib/constants";
import ExternalPartnerConnection from "../ExternalPartner/ExternalPartnerConnection";
import ExternalPartnerMenu from "../ExternalPartner/ExternalPartnerMenu";

interface Props {
  toggleOnly?: boolean;
  handleQuickActionExternalUpload: () => void;
  setShowUploadDocs: React.Dispatch<React.SetStateAction<boolean>>;
  handleChooseFile: (e: React.MouseEvent) => void;
}

export default function ExternalPartnerActions(props: Props) {
  const { user } = useAuth();
  const location = useLocation();
  const isUploadingResponse =
    new URLSearchParams(location.search).get(
      SEARCH_PARAMS.RESPONSE_TO_DISCOVERY,
    ) === "true";
  return (
    <>
      <ExternalPartnerConnection />
      {!props.toggleOnly && (
        <ExternalPartnerMenu
          user={user}
          externalAction={
            isUploadingResponse
              ? props.handleQuickActionExternalUpload
              : props.setShowUploadDocs
          }
          bpDefault={props.handleChooseFile}
        />
      )}
    </>
  );
}
